let precios = {
  iva: "IVA Incluido",

  preventa: "Preventa ahora",

  chasis_nhs: "NHS $111.990.000,00",
  chasis_nhs1: "NHS Camioneta $110.990.000,00",
  chasis_nhs2: "NHS XL $112.990.000,00",

  chasis_nqs: "$147.990.000,00",

  chasis_frs: "$153.990.000,00",

  tx_17000: "Largo MT $301.990.000,00",
  tx_170001: "Largo AMT $319.490.000,00",
  tx_170002: "XL AMT $332.990.000,00",

  tx_minimmula: "$386.990.000,00",

  tx_superMinimula: "TX 400 MT $413.990.000,00",
  tx_superMinimula1: "TX 400 AMT $431.990.000,00",

  tractor_6x4: "$485.990.000,00",

  tx400: "$589.990.000,00", 

  g7_540: "$566.990.000,00",

  g7s_540: "$521.990.000,00",
};

export default precios;
